/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const TYPE = {
  ARTIFACT: 'ARTIFACT',
  DATETIME: 'DATETIME',
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  SELECT_ONE: 'SELECT_ONE',
  SELECT_MULTI: 'SELECT_MULTI',
  SELECT_MULTI_USER: 'SELECT_MULTI_USER',
  SELECT_MULTI_GROUP: 'SELECT_MULTI_GROUP',
  SELECT_ONE_USER: 'SELECT_ONE_USER',
  SELECT_ONE_GROUP: 'SELECT_ONE_GROUP'
}

export type PropertyType = keyof typeof TYPE
